import styled from 'styled-components';

export const DetailContainer = styled.div<{ background?: string }>`
  max-width: 800px;
  margin: 0 auto;
  background: ${({background}) => background ? background : 'transparent'};
`;